import React from 'react';
import { JcApp, JcAsyncErrorBoundary, JcRouter } from 'jcsdk';
import { JCalAuthProvider } from 'src/app/auth/JCalAuthProvider';
import { jcalAppRoutingConfig } from 'src/app/routing/JCalAppRoutingConfig';

export const JCalApp = (): React.ReactElement => (
    <JcApp>
        <JcAsyncErrorBoundary>
            <JCalAuthProvider>
                <JcRouter config={jcalAppRoutingConfig} />
            </JCalAuthProvider>
        </JcAsyncErrorBoundary>
    </JcApp>
);
